import React from "react";
import { MessageCircle } from "lucide-react";
import { companyInfo } from "@/data/mock";

const Footer = () => {
  const year = new Date().getFullYear();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const openWA = () => {
    window.open(`https://wa.me/${companyInfo.whatsapp}`, "_blank");
  };

  return (
    <footer className="bg-gradient-to-br from-[#a00e21] via-[#8a0c1c] to-[#6d0916] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-lg overflow-hidden shadow-lg border-2 border-white bg-white">
                <img src={companyInfo.logo} alt="Logo SHAKTI" className="w-full h-full object-contain" />
              </div>
              <div>
                <h3 className="font-black text-xl">{companyInfo.brand}</h3>
                <p className="text-sm text-[#edf011] font-semibold">{companyInfo.name}</p>
              </div>
            </div>

           

            <p className="text-gray-200 text-sm leading-relaxed">
              Alamat: {companyInfo.address}
            </p>

            <div className="mt-4 text-sm text-gray-200 font-semibold">
              Website:
              <div className="mt-1">
                {companyInfo.websites.map((w) => (
                  <div key={w}>{w}</div>
                ))}
              </div>
            </div>
          </div>

          {/* Menu */}
          <div>
            <h4 className="font-black text-lg mb-4">Menu</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => scrollTo("hero")} className="text-gray-200 hover:text-[#edf011] font-semibold">Beranda</button></li>
              <li><button onClick={() => scrollTo("about")} className="text-gray-200 hover:text-[#edf011] font-semibold">Tentang Kami</button></li>
              <li><button onClick={() => scrollTo("produk")} className="text-gray-200 hover:text-[#edf011] font-semibold">Produk</button></li>
              <li><button onClick={() => scrollTo("kemasan")} className="text-gray-200 hover:text-[#edf011] font-semibold">Kemasan</button></li>
              <li><button onClick={() => scrollTo("sertifikasi")} className="text-gray-200 hover:text-[#edf011] font-semibold">Legalitas</button></li>
              <li><button onClick={() => scrollTo("kontak")} className="text-gray-200 hover:text-[#edf011] font-semibold">Kontak</button></li>
            </ul>
          </div>

          {/* Kontak */}
          <div>
            <h4 className="font-black text-lg mb-4">Kontak</h4>
            <ul className="space-y-3 text-sm text-gray-200">
              <li>
                <span className="text-gray-100 font-black">Telepon:</span><br />
                {companyInfo.phone}
              </li>
              <li>
                <span className="text-gray-100 font-black">Email:</span><br />
                {companyInfo.emailPrimary}<br />
                <span style={{ opacity: 0.85 }}>{companyInfo.emailSecondary}</span>
              </li>
              <li>
                <button
                  onClick={openWA}
                  className="inline-flex items-center space-x-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-black transition-colors"
                >
                  <MessageCircle size={16} />
                  <span>WhatsApp</span>
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 mt-10 pt-6 text-sm text-gray-200 font-semibold">
          © {year} {companyInfo.name}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
